export default __webpack_public_path__ + "static/media/win.eca5de69.gif";